import moment from "moment";
import React, { useState, useEffect } from "react";
import axiosInstance from "../../../../axios";
import { Loading } from "../../../Other/Loading";

const StudentUpcomingWebinar = () => {
  const [getUpcomingWebinar, setGetUpcomingWebinar] = useState();
  const [dataIndex, setDataIndex] = useState(5);
  const [fetchData, setFetchData] = useState(true);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  useEffect(() => {
    const fetchUpcomingWebinar = async () => {
      try {
        const res = await axiosInstance.get("/webinar/upcomming");
        setGetUpcomingWebinar(res?.data?.data || []);
      } catch (error) {
        console.error("Error fetching upcoming webinars:", error);
      } finally {
        setFetchData(false);
      }
    };

    fetchUpcomingWebinar();
  }, []);

  return (
    <div
      style={{
        background: "white",
        borderRadius: "24px",
        padding: "28px",
        border: "1px solid rgba(226, 232, 240, 0.8)",
        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.02)",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        fontFamily: "'Outfit', sans-serif",
      }}
    >
      <div>
        <p
          style={{
            margin: "0 0 4px 0",
            fontSize: "18px",
            fontWeight: "800",
            color: "#0f172a",
          }}
        >
          Upcoming Webinars
        </p>
        <p style={{ margin: "0 0 20px 0", fontSize: "13px", color: "#64748b", fontWeight: "500" }}>
          Live sessions with expert instructors
        </p>

        {fetchData && (
          <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
            {[...Array(3)].map((_, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "16px",
                  padding: "12px",
                  borderRadius: "16px",
                  background: "#ffffff",
                  border: "1px solid rgba(226, 232, 240, 0.5)",
                }}
              >
                <div className="skeleton" style={{ width: "56px", height: "56px", borderRadius: "12px", flexShrink: 0 }} />
                <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "6px" }}>
                  <span className="skeleton" style={{ width: "140px", height: "14px", borderRadius: "4px" }} />
                  <div style={{ display: "flex", gap: "8px", marginTop: "4px" }}>
                    <span className="skeleton" style={{ width: "80px", height: "10px", borderRadius: "3px" }} />
                    <span className="skeleton" style={{ width: "60px", height: "10px", borderRadius: "3px" }} />
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {!fetchData && getUpcomingWebinar && getUpcomingWebinar.length > 0 ? (
          <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
            {getUpcomingWebinar.slice(0, dataIndex).map((ele, index) => {
              const dateObj = moment(ele.webinarDate);
              const day = dateObj.format("DD");
              const month = dateObj.format("MMM").toUpperCase();

              // alternate color presets for badges
              const presets = [
                { bg: "#eff6ff", text: "#2563eb", border: "rgba(37, 99, 235, 0.1)" },
                { bg: "#ecfdf5", text: "#059669", border: "rgba(5, 150, 105, 0.1)" },
                { bg: "#fdf2f8", text: "#db2777", border: "rgba(219, 39, 119, 0.1)" },
                { bg: "#fffbeb", text: "#d97706", border: "rgba(217, 119, 6, 0.1)" },
              ];
              const preset = presets[index % presets.length];

              return (
                <div
                  key={index}
                  onMouseEnter={() => setHoveredIndex(index)}
                  onMouseLeave={() => setHoveredIndex(null)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "16px",
                    padding: "12px",
                    borderRadius: "16px",
                    background: hoveredIndex === index ? "#f8fafc" : "#ffffff",
                    border: "1px solid",
                    borderColor: hoveredIndex === index ? "#e2e8f0" : "rgba(226, 232, 240, 0.5)",
                    transition: "all 0.2s ease",
                  }}
                >
                  {/* Date Badge */}
                  <div
                    style={{
                      width: "56px",
                      height: "56px",
                      borderRadius: "12px",
                      background: preset.bg,
                      border: `1px solid ${preset.border}`,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <span style={{ fontSize: "10px", fontWeight: "800", color: preset.text, letterSpacing: "0.05em" }}>
                      {month}
                    </span>
                    <span style={{ fontSize: "20px", fontWeight: "800", color: preset.text, lineHeight: "1.1", marginTop: "2px" }}>
                      {day}
                    </span>
                  </div>

                  {/* Details */}
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <p
                      style={{
                        margin: 0,
                        fontSize: "14px",
                        fontWeight: "700",
                        color: "#0f172a",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {ele.eventName}
                    </p>
                    <p style={{ margin: "4px 0 0 0", fontSize: "12px", color: "#64748b", fontWeight: "600", display: "flex", alignItems: "center", gap: "6px" }}>
                      <span>🕒 {ele.startTime}</span>
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          !fetchData && (
            <div
              style={{
                padding: "30px",
                textAlign: "center",
                color: "#64748b",
                background: "#f8fafc",
                borderRadius: "16px",
                border: "1px dashed #cbd5e1",
              }}
            >
              No upcoming webinars scheduled
            </div>
          )
        )}
      </div>

      {!fetchData && getUpcomingWebinar && getUpcomingWebinar.length > 5 && (
        <div style={{ display: "flex", justifyContent: "center", marginTop: "16px" }}>
          <span
            onClick={() =>
              setDataIndex(dataIndex === 5 ? getUpcomingWebinar.length : 5)
            }
            style={{
              fontSize: "12px",
              fontWeight: "700",
              color: "#4f46e5",
              cursor: "pointer",
              transition: "color 0.2s",
            }}
          >
            {dataIndex === 5 ? "View All Webinars" : "View Less"}
          </span>
        </div>
      )}
    </div>
  );
};

export default StudentUpcomingWebinar;
